import { QPilotAccessToken } from "../../../core/services/qpilot.service";

/**
 * Customer event log entry from API
 * Matches old QMC QPilotEventLog structure
 */
export interface CustomerHistoryEntry {
  id: number;
  eventUtc: Date;
  userId?: number;
  siteId?: number;
  scheduledOrderId?: number;
  customerId?: number;
  paymentMethodId?: number;
  productId?: number;
  eventType: string;
  entityType: string;
  exceptionType: string;
  eventOriginatorType: EventOriginatorType;
  eventOriginatorId?: number;
  description: string;
  originatorFormatted: string;
  eventVerb: string;
  descriptionFormatted: string;
}

/**
 * Event originator type - who triggered the event
 */
export enum EventOriginatorType {
  User = 0,
  System = 1,
}

/**
 * History dialog data passed via DynamicDialog
 */
export interface CustomerHistoryDialogData {
  customerId: number;
  customerName?: string;
  siteId?: number;
  embeddedMode?: boolean;
  inputToken?: QPilotAccessToken;
}
